'use client';

import { useLayoutEffect } from 'react';
import { AD_LIGHT_STORAGE_KEY, applyAdLightDom, shouldApplyAdLightHint } from '@benzinga/ads-utils';

const syncAdLightDom = () => {
  if (typeof document === 'undefined') return;
  applyAdLightDom(
    shouldApplyAdLightHint({
      search: window.location.search,
      storageValue: localStorage.getItem(AD_LIGHT_STORAGE_KEY),
    }),
  );
};

export const AdLightHydrationGuard: React.FC = () => {
  syncAdLightDom();
  useLayoutEffect(() => {
    syncAdLightDom();
  }, []);
  return null;
};
